<footer class="profile-footer">
  <span class="profile-footer__brand">
    <span class="profile-footer__brand-icon" aria-hidden="true"></span>
    ROGERS
  </span>
  <span class="profile-footer__copyright">&copy; {{ currentYear }} Rogers Communications</span>
</footer>
